import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.hero = this.el.querySelector('.c-hero');
        if (this.hero) {
            this.title = this.hero.querySelector('.-h1');
            this.introduction = this.hero.querySelector('.c-hero_introduction');
            this.covers = this.hero.querySelectorAll('.c-hero_cover_media');
            this.scrollButton = this.hero.querySelector('.c-hero_scroll');
        }
        this.formWrap = this.el.querySelector('.formWrap');
        this.mainContent = this.el.querySelector('.mainContent');

        window.addEventListener('p-loaded', () => {
            this.animate();
        });
    }

    animate() {
        const startDelay = 0;

        let tl = gsap.timeline({ onComplete: () => {
            // this.call('start', 'Scroll');
        } });

        if (this.covers && this.covers.length) {
            tl.fromTo(this.covers,
                { rotate: 0, scale: 1.3 },
                { rotate: 0, scale: 1, ease: "circ.out", duration: 1.2 },
                startDelay
            );
        }

        if (this.title) {
            tl.fromTo(this.title.querySelectorAll('.word'),
                { y: "100%", rotate: 10, opacity: 0 },
                { y: "0%", rotate: 0, opacity: 1, ease: "expo.out", duration: 0.8, stagger: 0.06 },
                startDelay + 0.6
            );
        }

        if (this.scrollButton) {
            tl.fromTo(this.scrollButton,
                { scale: 0 },
                { scale: 1, ease: "expo.out", duration: 0.6 },
                startDelay + 1.2
            );
        }

        if (this.introduction) {
            tl.fromTo(this.introduction.querySelectorAll('.line'),
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, ease: "expo.out", duration: 0.6, stagger: 0.06 },
                startDelay + 0.8
            );
        }

        if (this.mainContent) {
            tl.fromTo(this.mainContent,
                { opacity: 0, y: 80 },
                { opacity: 1, y: 0, ease: "expo.out", duration: 0.8 },
                startDelay + 1
            );
        }

        if (this.formWrap) {
            tl.fromTo(this.formWrap,
                { opacity: 0, y: 80 },
                { opacity: 1, y: 0, ease: "expo.out", duration: 0.8 },
                startDelay + 1
            );
        }
    }
}
